import { Space, Button } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type NamirialSigningModuleSpecsFragment } from '../../../../api/fragments/NamirialSigningModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateNamirialForm from './UpdateNamirialForm';

export type UpdateNamirialDrawerProps = {
    onClose: () => void;
    visible: boolean;
    module: NamirialSigningModuleSpecsFragment;
};

const UpdateNamirialDrawer = ({ onClose, visible, module }: UpdateNamirialDrawerProps) => {
    const { t } = useTranslation(['namirialSigningModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('namirialSigningModuleDetails:updateNamirialDrawer.cancelButton')}
                    </Button>
                    <Button form="updateNamirial" htmlType="submit" type="primary">
                        {t('namirialSigningModuleDetails:updateNamirialDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('namirialSigningModuleDetails:updateNamirialDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateNamirialForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateNamirialDrawer;

export const useUpdateNamirialDrawer = (module: NamirialSigningModuleSpecsFragment) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <UpdateNamirialDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
